import { isPending } from "App/apiMiddleware";
import { REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import get from "lodash/get";
import startsWith from "lodash/startsWith";
import values from "lodash/values";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
import reduxStoreExternal from "./reduxStoreExternal";
export const getSummaryReportId = createSelector((state) => get(state, `[${REDUX_ROUTING_PAGE_NAMESPACE}].payload.summaryReportId`), (summaryReportId) => summaryReportId && Number.isFinite(Number(summaryReportId))
    ? Number(summaryReportId)
    : undefined);
export const getSummaryReportObjects = createSelector((state) => getSummaryReportId(state), (state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].dataKey[${getSummaryReportId(state)}]`), (summaryReportId, _) => summaryReportId && reduxStoreExternal.summaryReportObjects[summaryReportId]
    ? values(reduxStoreExternal.summaryReportObjects[summaryReportId])
    : undefined);
export const getInProgress = (state) => isPending(state, `${actionTypes.GET_SUMMARY_REPORT_OBJECTS}_${getSummaryReportId(state)}`) ||
    isPending(state, e => startsWith(e, `${actionTypes.GET_SUMMARY_REPORT_OBJECT}_${getSummaryReportId(state)}`));
